(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/ticker/views/winners.js') >= 0) return;  svs.modules.push('/widgets/ticker/views/winners.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.widget=_svs.widget||{};
_svs.widget.ticker=_svs.widget.ticker||{};
_svs.widget.ticker.templates=_svs.widget.ticker.templates||{};
svs.widget.ticker.templates.winners = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div aria-hidden=\"true\" class=\"ticker-item__badge ticker-item__letter-badge ticker-item__letter-badge--color-"
    + alias4(((helper = (helper = lookupProperty(helpers,"index") || (depth0 != null ? lookupProperty(depth0,"index") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"index","hash":{},"data":data,"loc":{"start":{"line":3,"column":113},"end":{"line":3,"column":122}}}) : helper)))
    + "\">\n      "
    + alias4(((helper = (helper = lookupProperty(helpers,"promoLetter") || (depth0 != null ? lookupProperty(depth0,"promoLetter") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"promoLetter","hash":{},"data":data,"loc":{"start":{"line":4,"column":6},"end":{"line":4,"column":21}}}) : helper)))
    + "\n    </div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div aria-hidden=\"true\" class=\"ticker-item__badge ticker-item__icon-badge\">\n      "
    + container.escapeExpression((lookupProperty(helpers,"ui")||(depth0 && lookupProperty(depth0,"ui"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"icon",{"name":"ui","hash":{"icon":"jackpot","color":"fc-white","size":"100"},"data":data,"loc":{"start":{"line":8,"column":6},"end":{"line":8,"column":62}}}))
    + "\n    </div>\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\n      <a\n        class=\"ticker-item__game-link\"\n        href='"
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"winner") : depth0)) != null ? lookupProperty(stack1,"href") : stack1), depth0))
    + "'\n      >\n        "
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"winner") : depth0)) != null ? lookupProperty(stack1,"gameName") : stack1), depth0))
    + "\n      </a>\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"winner") : depth0)) != null ? lookupProperty(stack1,"gameName") : stack1), depth0))
    + "\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3=container.lambda, alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"ticker-item\">\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"brand") : depth0),"===","bingo",{"name":"compare","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":2,"column":2},"end":{"line":10,"column":14}}})) != null ? stack1 : "")
    + "  <span aria-label=\""
    + alias4(alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"winner") : depth0)) != null ? lookupProperty(stack1,"amountSek") : stack1), depth0))
    + " kr vinst på "
    + alias4(alias3(((stack1 = (depth0 != null ? lookupProperty(depth0,"winner") : depth0)) != null ? lookupProperty(stack1,"gameName") : stack1), depth0))
    + "\" class=\"ticker-item__game-name\">\n    "
    + alias4((lookupProperty(helpers,"formatCurrency")||(depth0 && lookupProperty(depth0,"formatCurrency"))||alias2).call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"winner") : depth0)) != null ? lookupProperty(stack1,"amountSek") : stack1),{"name":"formatCurrency","hash":{},"data":data,"loc":{"start":{"line":12,"column":4},"end":{"line":12,"column":39}}}))
    + " kr vinst på "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"winner") : depth0)) != null ? lookupProperty(stack1,"href") : stack1),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.program(7, data, 0),"data":data,"loc":{"start":{"line":12,"column":52},"end":{"line":21,"column":13}}})) != null ? stack1 : "")
    + "  </span>\n</div>\n";
},"useData":true});
Handlebars.partials['widget-ticker-winners'] = svs.widget.ticker.templates.winners;
})(svs, Handlebars);


 })(window);